import {i18n} from 'i18n';


export const FallbackErrorTextConst = i18n.t('Something went wrong');
